// extracted by mini-css-extract-plugin
module.exports = {"popover":"NavMore_popover__9pjUZ","btns":"NavMore_btns__3tI2z","btn":"NavMore_btn__3Y3MX","selected":"NavMore_selected__2GJie","link":"NavMore_link__16x9l"};